// Module
var code = "<div id=\"umc-tabpanel\" role=\"tabpanel\" aria-labelledby=\"umc-tab-{{umc.currentSection.name}}\" class=\"universal-media-chooser {{umc.currentSection.directive}}\"><div class=\"media-chooser-component\"></div></div>";
// Exports
module.exports = code;